module.exports = __webpack_public_path__ + "23_pvis2.jpg?c4bfd58ca60e99a05cb9a4a5118acda7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/23_pvis2.jpg
// module id = 202
// module chunks = 0